import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { setRangeValue } from "../../Utils/NumberUtils";
export var ColorAnimation = /*#__PURE__*/function () {
  function ColorAnimation() {
    _classCallCheck(this, ColorAnimation);
    this.count = 0;
    this.enable = false;
    this.offset = 0;
    this.speed = 1;
    this.sync = true;
  }
  _createClass(ColorAnimation, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.count !== undefined) {
        this.count = setRangeValue(data.count);
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.offset !== undefined) {
        this.offset = setRangeValue(data.offset);
      }
      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }
      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);
  return ColorAnimation;
}();